import { useEffect,useState } from 'react'
import { useEntityCrud } from '../../hooks/useEntityCrud'
import ReactSelect from 'react-select'
import InputMask from 'react-input-mask'
import Chart from 'react-apexcharts'
import DatePicker from '@hassanmojab/react-modern-calendar-datepicker';

const Index = () => {

    const [reports,setReports] = useState([])
    const [fromDate,setFromDate] = useState('')
    const [toDate,setToDate] = useState('')
    const [businesses,setBusinesses] = useState([])
    const {readData: getBusinesses} = useEntityCrud('Business/GetAllBusiness')
    const [businessId,setBusinessId] = useState(0)
    const [groups,setGroups] = useState([])
    const {readData: getGroups} = useEntityCrud(`Group/GetAllGroups?buisnessId=${businessId?.value}`)
    const [groupId,setGroupId] = useState(0)
    const [services,setServices] = useState([])
    const {readData: getServices} = useEntityCrud(`Service/GetAllservices?groupId=${groupId?.value}`)
    const [serviceId,setServiceId] = useState(0)
    const [subServices,setSubServices] = useState([])
    const {readData: getSubServices} = useEntityCrud(`SubService/GetAllSubservices?serviceId=${serviceId?.value}`)
    const [subServiceId,setSubServiceId] = useState(0)
    const {readData: getReportsData} = useEntityCrud('Report/PriceHistory')
    const [chartOptions,setChartOptions] = useState({})

    const convertToGregorian = date => date.year.toString() + (date.month > 9 ? date.month.toString() : ('0' + date.month)) + (date.day > 9 ? date.day.toString() : ('0' + date.day))

    useEffect(() => {
        getBusinesses().then(({data}) => {
            let businessesList = []
            if(data.status)
                data.result.map(b => businessesList.push({
                    label: b.title,
                    isActive: b.isActive,
                    value: b.id
                }))
            setBusinesses(businessesList)
        })
    },[])

    useEffect(() => {
        if(businessId){
            setGroups([])
            setGroupId(0)
            setServices([])
            setServiceId(0)
            setSubServices([])
            setSubServiceId(0)
            getGroups().then(({data}) => {
                let groupsList = []
                if(data.status)
                    data.result.map(b => groupsList.push({
                        label: b.title,
                        isActive: b.isActive,
                        value: b.id
                    }))
                setGroups(groupsList)
            })
        }
    },[businessId])

    useEffect(() => {
        if(groupId){
            setServices([])
            setServiceId(0)
            setSubServices([])
            setSubServiceId(0)
            getServices().then(({data}) => {
                let servicesList = []
                if(data.status)
                    data.result.map(b => servicesList.push({
                        label: b.title,
                        isActive: b.isActive,
                        value: b.id
                    }))
                setServices(servicesList)
            })
        }
    },[groupId])

    useEffect(() => {
        if(serviceId){
            setSubServices([])
            setSubServiceId(0)
            getSubServices().then(({data}) => {
                let subServicesList = []
                if(data.status)
                    data.result.map(b => subServicesList.push({
                        label: b.title,
                        isActive: b.isActive,
                        value: b.id
                    }))
                setSubServices(subServicesList)
            })
        }
    },[serviceId])

    const getReports = () => {
        const postedData = {
            p_subserviceid: subServiceId.value,
            p_fromdate: parseInt(convertToGregorian(fromDate)),
            p_todate: parseInt(convertToGregorian(toDate))
        }
        getReportsData(postedData).then(({data}) => {
            if(data.status && data.result && data.result.v_result){
                let categories = []
                let prices = []
                data.result.v_result.map(row => {
                    categories.push(`${row.modify_date.slice(0,4)}/${row.modify_date.slice(4,6)}/${row.modify_date.slice(6,8)}`)
                    prices.push(row.price)
                    setChartOptions({
                        options: {
                            chart: {
                                id: 'basic-bar'
                            },
                            xaxis: {
                                categories
                            },
                            dataLabels: {
                                enabled: true,
                                formatter: function (val){
                                    return new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(val)
                                }
                            },
                            tooltip: {
                                enabled: true,
                                shared: true,
                                followCursor: false,
                                intersect: false,
                                inverseOrder: false,
                                hideEmptySeries: true,
                                x: {
                                    show: true,
                                    formatter: function(val,{dataPointIndex}){
                                        const item = data.result.v_result.find((r,i) => i == dataPointIndex)
                                        return `${item?.user_name} - ${`${row.modify_date.slice(0,4)}/${row.modify_date.slice(4,6)}/${row.modify_date.slice(6,8)}`}`
                                    }
                                },
                                y: {
                                    show: true,
                                    formatter: function(val){
                                        return new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(val)
                                    }
                                },
                                z: {
                                    show: true,
                                    formatter: function(val){
                                        return val
                                    }
                                }
                            }
                        },
                        series: [
                            {
                                name: 'قیمت ',
                                data: prices
                            }
                        ],
                        
                    })
                })
            }
        })
    }

    return (
        <div className="card">
            <div className="card-header">
                <div className="card-title">تاریخچه قیمت ها</div>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-md-3">
                        <div className="form-group">
                            <label>کسب و کار <span className="text-danger">*</span></label>
                            <div className="position-relative" style={{zIndex: 3}}>
                                <ReactSelect
                                    options={businesses.filter(item => item.isActive)}
                                    value={businessId}
                                    onChange={value => setBusinessId(value)}
                                    placeholder="انتخاب کنید"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <label>گروه <span className="text-danger">*</span></label>
                            <div className="position-relative" style={{zIndex: 3}}>
                                <ReactSelect
                                    options={groups.filter(item => item.isActive)}
                                    isDisabled={!groups.length}
                                    value={groupId}
                                    onChange={value => setGroupId(value)}
                                    placeholder="انتخاب کنید"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <label>سرویس <span className="text-danger">*</span></label>
                            <ReactSelect
                                options={services.filter(item => item.isActive)}
                                isDisabled={!services.length}
                                value={serviceId}
                                onChange={value => setServiceId(value)}
                                placeholder="انتخاب کنید"
                            />
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <label>محصول / خدمت <span className="text-danger">*</span></label>
                            <ReactSelect
                                options={subServices.filter(item => item.isActive)}
                                isDisabled={!subServices.length}
                                value={subServiceId}
                                onChange={value => setSubServiceId(value)}
                                placeholder="انتخاب کنید"
                            />
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <label>از تاریخ <span className="text-danger">*</span></label>
                            {fromDate && <i class="fe fe-x clear-select-btn" onClick={() => setFromDate(null)} style={{left: 25}}></i>}
                            <DatePicker
                                locale="fa"
                                shouldHighlightWeekends
                                value={fromDate}
                                onChange={setFromDate}
                                className="form-control my-1 pb-4"
                            />
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <label>تا تاریخ <span className="text-danger">*</span></label>
                            {toDate && <i class="fe fe-x clear-select-btn" onClick={() => setToDate(null)} style={{left: 25}}></i>}
                            <DatePicker
                                locale="fa"
                                shouldHighlightWeekends
                                value={toDate}
                                onChange={setToDate}
                                className="form-control my-1 pb-4"
                            />
                        </div>
                    </div>
                    <div className="col-md-2" style={{marginTop: 30}}>
                        <button className="btn btn-primary" onClick={getReports} disabled={!fromDate || !toDate || !subServiceId}>مشاهده تاریخچه</button>
                    </div>
                </div>
                {chartOptions.options && <hr className="mb-5" />}
                {chartOptions.options && <Chart
                    options={chartOptions.options}
                    series={chartOptions.series}
                    type="area"
                    width="100%"
                    height="500px"
                />}
            </div>
        </div>
    )
}

export default Index